import { UserDeviceDetails } from '@models/PostHog'
import { useTenant } from '@modules/tenant/contexts/tenant/TenantContext'
import { Space, Tag, Tooltip, Typography } from 'antd'

const { Text } = Typography

interface Props {
  device: UserDeviceDetails
}

const InnerUserDeviceDetails = ({ device }: Props) => {
  const { allPlatforms } = useTenant()

  return (
    <Space className="w-full space-between">
      <Space size={4}>
        {device.os == 'iOS' && (
          <>
            {allPlatforms.ios.icon}
            <Text>{allPlatforms.ios.name} Application</Text>
          </>
        )}
        {device.os == 'Android' && (
          <>
            {allPlatforms.android.icon}
            <Text>{allPlatforms.android.name} Application</Text>
          </>
        )}
      </Space>
      <Space>
        <Tooltip title={'Device os informations'}>
          <Tag color="purple">
            {device.os} - {device.osVersion}
          </Tag>
        </Tooltip>
        <Tooltip title={'App informations'}>
          <Tag color="green">{`${device.appVersion} (${device.appBuild})`}</Tag>
        </Tooltip>
      </Space>
    </Space>
  )
}

export default InnerUserDeviceDetails
